// extracted by mini-css-extract-plugin
export default {"loading":"Coin_loading__Xx5N+","text_left":"Coin_text_left__HeVan","boxTable":"Coin_boxTable__Zcg1r","table":"Coin_table__uesyY","box_search":"Coin_box_search__CK-u+"};